import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { ProductionApi } from '../production.api';

export const useGetProductionCalculations = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: ProductionApi.getProductionCalculations,
  });
};
